@if (footerState$ | async; as state) {
  @switch (state.type) {
    @case (TaskFooterType.Transfer) {
      <app-footer-transfer [task]="state.connectedTask" [isTransferDisabled]="state.isTransferDisabled"></app-footer-transfer>
    }
    @case (TaskFooterType.OnHold) {
      <app-footer-on-hold [task]="state.connectedTask"></app-footer-on-hold>
    }
    @case (TaskFooterType.ConnectedInfo) {
      <app-footer-connected [task]="state.connectedTask"></app-footer-connected>
    }
    @case (TaskFooterType.IncomingInfo) {
      <app-footer-incoming [task]="state.incomingTask"></app-footer-incoming>
    }
    @case (TaskFooterType.Parked) {
      <app-footer-parked></app-footer-parked>
    }
    @case (TaskFooterType.NarRequest) {
      <app-footer-nar [message]="state.narMessage"></app-footer-nar>
    }
  }
}
